import selectionService from '../../services/ClassenService/modules/selectionService';

const state = {
  selections: [],
  selectionSuggestions: [],
};

const getters = {
  getSelections() {
    return state.selections;
  },

  getSelectionSuggestions() {
    return state.selectionSuggestions;
  }
};

const mutations = {
  SET_SELECTIONS: (state, selections) => {
    state.selections = selections;
  },

  SET_SELECTION_SUGGESTIONS: (state, selectionSuggestions) => {
    state.selectionSuggestions = selectionSuggestions;
  },

  ADD_SELECTION: (state, selection) => {
    state.selectionSuggestions.unshift(selection);
    state.selections.push(selection);
  },
};

const actions = {
  getSelections: (context) => {
    if (context.state.selections.length === 0) {
      context.commit('SET_SELECTIONS', ["loading"]);
      selectionService.getSelections().then((response) => {
        context.commit('SET_SELECTIONS', response.data)
      });
    }
    return context.state.selections
  },

  forceReloadSelections: (context) => {
    selectionService.getSelections().then((response) => {
      context.commit('SET_SELECTIONS', response.data)
    });
  },

  getSelectionSuggestions: (context) => {
    selectionService.getSelectionSuggestions().then((response) => {
      context.commit('SET_SELECTION_SUGGESTIONS', response.data)
    });
    return context.state.selectionSuggestions
  },

  addProductToSelection: (context, data) => {
    let prom = selectionService.addProductToSelection(data.selectionId, data.productId);
    context.dispatch('getSelectionSuggestions');
    return prom;
  },

  addDecorToSelection: (context, data) => {
    let prom = selectionService.addDecorToSelection(data.selectionId, data.decorId);
    context.dispatch('getSelectionSuggestions');
    return prom;
  },

  uploadSelectionLogo: (context, data) => {
    return selectionService.uploadSelectionLogo(data);
  },

  removeProductFromSelection: (context, data) => {
    return selectionService.removeProductFromSelection(data.selectionId, data.productId);
  },

  removeDecorFromSelection: (context, data) => {
    return selectionService.removeDecorFromSelection(data.selectionId, data.decorId);
  },

  getSelection: ({commit}, selectionId) => new Promise((resolve, reject) => {
    selectionService.getSelection(selectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getSelectionItems: ({commit}, data) => new Promise((resolve, reject) => {
    selectionService.getSelectionItems(data.selectionId, data.page)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  duplicateSelection: ({commit}, selectionId) => new Promise((resolve, reject) => {
    selectionService.duplicateSelection(selectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateSelection: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.updateSelection(selectionData.id, selectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteSelection: ({commit}, selectionId) => new Promise((resolve, reject) => {
    selectionService.deleteSelection(selectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteSelectionItem: ({commit}, selectionItemId) => new Promise((resolve, reject) => {
    selectionService.deleteSelectionItem(selectionItemId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addSelection: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.addSelection(selectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getHRImages: ({commit}, selectionId) => new Promise((resolve, reject) => {
    selectionService.getHRImages(selectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  requestImages: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.requestImages(selectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  generateExcel: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.generateExcel(selectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getGenerateExcelStatus: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.getGenerateExcelStatus(selectionData)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
  }),

  generateSelectionPdf: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.generateSelectionPdf(selectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getGenerateSelectionPdfStatus: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.getGenerateSelectionPdfStatus(selectionData)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
  }),

  generateLink: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.generateLink(selectionData.selectionId, selectionData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getSharedSelection: ({commit}, selectionId) => new Promise((resolve, reject) => {
    selectionService.getSharedSelection(selectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getSharedSelectionItems: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.getSharedSelectionItems(selectionData.sharedSelectionId, selectionData.page)
        .then((response) => resolve(response))
        .catch((error) => reject(error));
  }),

  getSharedSelectionLanguages: () => new Promise((resolve, reject) => {
    selectionService.getSharedSelectionLanguages()
        .then((response) => resolve(response))
        .catch((error) => reject(error));
  }),

  getInformationForSharedSelection: ({commit}, selectionId) => new Promise((resolve, reject) => {
    selectionService.getInformationForSharedSelection(selectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getProductForSharedSelection: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.getProductForSharedSelection(selectionData.selectionId, selectionData.productId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getDecorForSharedSelection: ({commit}, selectionData) => new Promise((resolve, reject) => {
    selectionService.getDecorForSharedSelection(selectionData.selectionId, selectionData.decorId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getSelectionLists: ({commit}, selectionId) => new Promise((resolve, reject) => {
    selectionService.getSelectionLists(selectionId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getSelectionList: ({commit}, selectionId, selectionListId) => new Promise((resolve, reject) => {
    selectionService.getSelectionList(selectionId, selectionListId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateSelectionList: ({commit}, selectionId, selectionListId, selectionListData) => new Promise((resolve, reject) => {
    selectionService.updateSelectionList(selectionId, selectionListId, selectionListData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteSelectionList: ({commit}, selectionId, selectionListId) => new Promise((resolve, reject) => {
    selectionService.deleteSelectionList(selectionId, selectionListId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addSelectionList: ({commit}, selectionId, selectionListData) => new Promise((resolve, reject) => {
    selectionService.addSelectionList(selectionId, selectionListData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getSelectionListItems: ({commit}, selectionListId) => new Promise((resolve, reject) => {
    selectionService.getSelectionListItems(selectionListId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  getSelectionListItem: ({commit}, selectionListId, selectionListItemId) => new Promise((resolve, reject) => {
    selectionService.getSelectionListItem(selectionListId, selectionListItemId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  addSelectionListItem: ({commit}, selectionListId, selectionListItemData) => new Promise((resolve, reject) => {
    selectionService.addSelectionListItem(selectionListId, selectionListItemData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  updateSelectionListItem: ({commit}, selectionListItemId, selectionListItemData) => new Promise((resolve, reject) => {
    selectionService.updateSelectionListItem(selectionListItemId, selectionListItemData)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),

  deleteSelectionListItem: ({commit}, selectionListId, selectionListItemId) => new Promise((resolve, reject) => {
    selectionService.deleteSelectionListItem(selectionListId, selectionListItemId)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  }),
};

export default {
  state, mutations, getters, actions,
};
